import { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import FJVideoRemoveBgCustomObjectPreview from '../view/FJVideoRemoveBgCustomObjectPreview';
import { useDispatch, useSelector } from 'react-redux';
import FJActionVideoRemoveBg from '../../../../redux/action/FJActionVideoRemoveBg';
import FJConstant from '../../../../constants/FJConstant';
import FJUtil from '../../../../util/FJUtil';
import useLocalStore from '../../../../hooks/useLocalStore';

const FJVideoRemoveBgCustomObjectPreviewContainer = memo(({ isShow }) => {
    useLocalStore();
    const dispatch = useDispatch();

    const tracklets = useSelector(state => state.videoBgRemover.tracklets);
    const hasPointLoading = useSelector(state => state.videoBgRemover.hasPointLoading);
    const customRemoverStatus = useSelector(state => state.videoBgRemover.customRemoverStatus);
    const currentTime = useSelector(state => state.videoBgRemover.currentTime);

    const hasPoint = useMemo(() => {
        if (!tracklets) return false;
        return tracklets.some(tracklet => tracklet.masks.length > 0);
    }, [tracklets]);

    const _setSelectObjectPreviewCanvas = useCallback(
        canvas => {
            dispatch(FJActionVideoRemoveBg.setCustomObjectPreviewCanvasAction(canvas));
        },
        [dispatch],
    );

    const _onDeleteAllPoint = useCallback(() => {
        dispatch(FJActionVideoRemoveBg.deleteAllPointAction());
    }, [dispatch]);

    const _onLocationObject = useCallback(() => {
        const nextTime = tracklets[0].currentTime;
        if (nextTime === null || nextTime === undefined) return;
        dispatch(FJActionVideoRemoveBg.seekAction(nextTime));
    }, [dispatch, tracklets]);

    return isShow ? (
        <FJVideoRemoveBgCustomObjectPreview
            setSelectObjectPreviewCanvas={_setSelectObjectPreviewCanvas}
            hasPoint={hasPoint}
            hasPointLoading={hasPointLoading}
            isDisabled={customRemoverStatus !== FJConstant.DEFAULT}
            locationIconIsDisabled={FJUtil.compareTimes(currentTime, tracklets[0]?.currentTime)}
            onDeleteAllPoint={_onDeleteAllPoint}
            onLocationObject={_onLocationObject}
        />
    ) : null;
});

FJVideoRemoveBgCustomObjectPreviewContainer.displayName = 'FJVideoRemoveBgCustomObjectPreviewContainer';

FJVideoRemoveBgCustomObjectPreviewContainer.propTypes = {
    isShow: PropTypes.bool,
};

export default FJVideoRemoveBgCustomObjectPreviewContainer;
